import { render, staticRenderFns } from "./BancaEmaticaOperatoriList.vue?vue&type=template&id=16c926ef"
import script from "./BancaEmaticaOperatoriList.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaOperatoriList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports